import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'

const ModalPreviewLogo = props => (
  <Dialog
    title="Preview Logo"
    modal={false}
    open={props.isOpenModalPreviewLogo}
    onRequestClose={props.setOpenModalPreviewLogo(false)}
    bodyStyle={{ textAlign: 'center' }}
    autoScrollBodyContent
  >
    <img src={props.imageLogo} alt="preview logo" />
  </Dialog>
)

ModalPreviewLogo.defaultProps = {
  isOpenModalPreviewLogo: false,
  setOpenModalPreviewLogo: () => { },
  imageLogo: '',
}

ModalPreviewLogo.propTypes = {
  isOpenModalPreviewLogo: PropTypes.bool,
  setOpenModalPreviewLogo: PropTypes.func,
  imageLogo: PropTypes.string,
}

export default ModalPreviewLogo

